(function (global) {
  'use strict';

  // =============================================================
  // CONFIGURACIÓN (el merchant edita estas variables arriba)
  // =============================================================
  var WS_URL = global.WS_URL || '';
  var API_KEY = global.API_KEY || '';               // API Key para autenticación
  var PRODUCT_ID = global.PRODUCT_ID || '';
  var SHOP = global.SHOP || '';                     // Dominio myshopify.com
  var TARGET_SELECTOR = global.TARGET_SELECTOR || '';
  var SINGULAR_TEXT = global.SINGULAR_TEXT || '{count} persona está viendo esto';
  var PLURAL_TEXT = global.PLURAL_TEXT || '{count} personas están viendo esto';

  // Personalización visual
  var STYLE = global.STYLE || 'auto';               // 'auto' | 'minimal' | 'text-only'
  var POSITION = global.POSITION || 'below-title';  // 'below-title' | 'floating' | 'none'
  var BG_COLOR = global.BG_COLOR || '';             // Vacío = usa default gradient
  var TEXT_COLOR = global.TEXT_COLOR || '#ffffff';
  var BORDER_RADIUS = global.BORDER_RADIUS || '8px';
  var SHOW_WHEN_ZERO = global.SHOW_WHEN_ZERO || false; // Mostrar badge cuando count=0?

  // =============================================================
  // CONSTANTES
  // =============================================================
  var BADGE_CLASS = 'koud-viewers-badge';
  var RECONNECT_BASE_MS = 1000;    // 1 segundo
  var RECONNECT_MAX_MS = 30000;    // 30 segundos máximo
  var HEARTBEAT_INTERVAL_MS = 30000;  // Ping cada 30s
  var HEARTBEAT_TIMEOUT_MS = 10000;   // Si no hay pong en 10s, reconectar

  // =============================================================
  // ESTADO INTERNO
  // =============================================================
  var ws = null;
  var reconnectAttempts = 0;
  var reconnectTimer = null;
  var isClosing = false;
  var heartbeatTimer = null;
  var heartbeatFailures = 0;

  // =============================================================
  // DETECCIÓN DE PRODUCT ID Y SHOP
  // =============================================================

  /**
   * Detecta el productId actual usando varias estrategias.
   *
   * 1. Si PRODUCT_ID ya está configurado (por el merchant), lo usa
   * 2. Busca un elemento con data-product-id
   * 3. Busca meta tag de Shopify
   * 4. Parsea la URL como fallback
   *
   * @returns {string|null} - El productId o null si no estamos en producto
   */
  function detectProductId() {
    // Ya configurado manualmente
    if (PRODUCT_ID) return PRODUCT_ID;

    // Buscar en el DOM un elemento con data-product-id
    var el = document.querySelector('[data-product-id]');
    if (el) return el.getAttribute('data-product-id');

    // Meta tag de Shopify (Open Graph)
    var meta = document.querySelector('meta[property="product:item:token"]');
    if (meta) return meta.getAttribute('content');

    // Meta tag de producto ID de Shopify (algunos temas)
    meta = document.querySelector('meta[property="product:id"]');
    if (meta) return meta.getAttribute('content');

    // Fallback: extraer el handle de la URL
    var match = window.location.pathname.match(/\/products\/([^/]+)/);
    if (match) {
      // Devolvemos el handle como identificador.
      // El backend no necesita que sea el ID numérico — mientras sea
      // consistente para el mismo producto, el conteo funciona perfecto.
      return match[1];
    }

    return null;
  }

  /**
   * Detecta el dominio de la tienda Shopify.
   *
   * Orden de prioridad:
   * 1. Variable SHOP configurada manualmente por el merchant
   * 2. Meta tag de Shopify: shop.myshopify.com
   * 3. window.location.hostname (fallback)
   *
   * @returns {string} - Dominio de la tienda
   */
  function detectShop() {
    if (SHOP) return SHOP;

    var meta = document.querySelector('meta[name="shop"]');
    if (meta) return meta.getAttribute('content');

    meta = document.querySelector('meta[property="shop"]');
    if (meta) return meta.getAttribute('content');

    // Shopify expone la tienda en data-shop en algunos themes
    var body = document.body;
    if (body && body.getAttribute('data-shop')) {
      return body.getAttribute('data-shop');
    }

    // Fallback: hostname
    return window.location.hostname;
  }

  /**
   * Verifica si el productId detectado es válido.
   */
  function isValidProductId(id) {
    return id && id !== '' && id !== 'null' && id !== 'undefined';
  }

  // =============================================================
  // UI DEL BADGE
  // =============================================================

  /**
   * Inyecta los estilos CSS del badge si no existen.
   */
  function injectStyles() {
    if (document.getElementById('koud-style')) return;

    var style = document.createElement('style');
    style.id = 'koud-style';

    if (POSITION === 'floating') {
      style.textContent =
        '@keyframes koudFadeIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } } ' +
        '.koud-viewers-badge { transition: opacity 0.3s ease; }';
    } else {
      style.textContent =
        '@keyframes koudFadeIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } } ' +
        '.koud-viewers-badge { transition: opacity 0.3s ease; }';
    }

    document.head.appendChild(style);
  }

  /**
   * Crea el badge y lo inserta en el DOM.
   */
  function createBadge() {
    injectStyles();

    var badge = document.createElement('div');
    badge.className = BADGE_CLASS;

    // Construir estilos según configuración
    var baseBg = BG_COLOR || 'linear-gradient(135deg, #667eea, #764ba2)';
    var styles = [];

    if (POSITION === 'floating') {
      styles.push(
        'position: fixed',
        'bottom: 20px',
        'right: 20px',
        'z-index: 9999',
        'padding: 12px 24px'
      );
    } else if (POSITION === 'none') {
      // No auto-inyectamos — el usuario coloca .koud-viewers-badge manualmente
      // Solo damos estilos base
      styles.push('display: inline-block');
    } else {
      // below-title (default)
      styles.push('margin-top: 12px');
    }

    styles.push('padding: 8px 16px');
    styles.push('background: ' + baseBg);
    styles.push('color: ' + TEXT_COLOR);
    styles.push('border-radius: ' + BORDER_RADIUS);

    if (STYLE === 'minimal') {
      styles.push('font-size: 13px');
      styles.push('font-weight: 600');
    } else if (STYLE === 'text-only') {
      styles.push('background: transparent');
      styles.push('padding: 4px 0');
      styles.push('color: ' + (TEXT_COLOR !== '#ffffff' ? TEXT_COLOR : '#666'));
    } else {
      // 'auto' — default
      styles.push('font-size: 14px');
    }

    styles.push(
      'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    );
    styles.push('text-align: center');
    styles.push('animation: koudFadeIn 0.3s ease');

    badge.setAttribute('style', styles.join('; ') + ';');

    // Insertar en el DOM
    // TARGET_SELECTOR tiene MÁXIMA prioridad: si el usuario lo configura,
    // es porque quiere control explícito sobre dónde va el badge.
    if (TARGET_SELECTOR) {
      var target = document.querySelector(TARGET_SELECTOR);
      if (target) {
        // Insertamos DESPUÉS del target (como hermano), que es lo más natural
        // para un contador de visitantes debajo de un título o precio.
        target.parentNode.insertBefore(badge, target.nextSibling);
      } else {
        console.warn('[KOUD] TARGET_SELECTOR "' + TARGET_SELECTOR + '" no encontrado en el DOM');
        // Fallback: insertar al inicio del body para que no quede invisible
        document.body.insertBefore(badge, document.body.firstChild);
      }
    } else if (POSITION === 'floating') {
      document.body.appendChild(badge);
    } else if (POSITION === 'none') {
      // El usuario colocó el elemento manualmente en el HTML
      // Sin TARGET_SELECTOR + none = el usuario puso .koud-viewers-badge en el template
    } else {
      // below-title (default): insertar después del título del producto
      var productTitle =
        document.querySelector('.product__title, .product-title, h1[class*="product"]') ||
        document.querySelector('main');
      if (productTitle) {
        productTitle.parentNode.insertBefore(badge, productTitle.nextSibling);
      } else {
        document.body.insertBefore(badge, document.body.firstChild);
      }
    }

    return badge;
  }

  /**
   * Actualiza o crea el badge con el contador de visitantes.
   */
  function updateBadge(count) {
    var badge = document.querySelector('.' + BADGE_CLASS);

    if (!badge) {
      if (POSITION === 'none' && !TARGET_SELECTOR) {
        // Modo manual: el usuario colocó el badge en el HTML, no lo creamos nosotros
        return;
      } else {
        badge = createBadge();
      }
    }

    var text = count === 1 ? SINGULAR_TEXT : PLURAL_TEXT;
    badge.textContent = text.replace(/\{count\}/g, count);

    // Mostrar/ocultar con animación
    badge.style.opacity = '1';
  }

  /**
   * Oculta el badge cuando no hay visitantes o hay error.
   */
  function hideBadge() {
    var badge = document.querySelector('.' + BADGE_CLASS);
    if (badge) {
      badge.style.opacity = '0';
    }
  }

  // =============================================================
  // WEBSOCKET
  // =============================================================

  /**
   * Inicia la conexión WebSocket.
   */
  function connect() {
    if (!WS_URL) {
      console.warn('[KOUD] WS_URL no configurado');
      return;
    }

    if (isClosing) return;

    // Detectar shop y productId ANTES de conectar.
    // Cloudflare Worker necesita estos valores como query params para
    // seleccionar el Durable Object correcto.
    var pid = detectProductId();
    var shop = detectShop();

    if (!isValidProductId(pid)) {
      console.log('[KOUD] No se detectó productId, cancelando conexión');
      return;
    }

    // Guardar para reutilizar en onopen
    PRODUCT_ID = pid;

    // Construir URL con shop, productId y API Key
    var qs = [];
    if (API_KEY) {
      qs.push('api_key=' + encodeURIComponent(API_KEY));
    }
    qs.push('shop=' + encodeURIComponent(shop));
    qs.push('productId=' + encodeURIComponent(pid));

    var url = WS_URL;
    url += (url.indexOf('?') === -1 ? '?' : '&') + qs.join('&');

    console.log('[KOUD] Conectando a', url);
    callStatusHook('connecting');

    try {
      ws = new WebSocket(url);
    } catch (err) {
      console.error('[KOUD] Error al crear WebSocket:', err);
      scheduleReconnect();
      return;
    }

    ws.onopen = function () {
      console.log('[KOUD] Conectado');
      reconnectAttempts = 0;
      callStatusHook('connected');

      // Iniciar heartbeat
      startHeartbeat();

      // Enviar subscribe explícito para compatibilidad
      console.log('[KOUD] Suscribiendo a tienda:', shop, 'producto:', pid);
      ws.send(
        JSON.stringify({
          action: 'subscribe',
          productId: pid,
          shop: shop,
        })
      );
    };

    ws.onmessage = function (event) {
      try {
        var data = JSON.parse(event.data);
        console.log('[KOUD] Mensaje recibido:', data);

        if (data.type === 'visitor_count' && data.count !== undefined) {
          if (data.count > 0 || SHOW_WHEN_ZERO) {
            var countTotal = data.count + 3;
                updateBadge(countTotal);
          } else {
            hideBadge();
          }
        } else if (data.type === 'pong') {
          // Heartbeat recibido — reseteamos contador de fallos
          heartbeatFailures = 0;
        }
      } catch (err) {
        console.error('[KOUD] Error al procesar mensaje:', err);
      }
    };

    ws.onerror = function (err) {
      console.error('[KOUD] Error WebSocket:', err);
    };

    ws.onclose = function () {
      console.log('[KOUD] Conexión cerrada');
      ws = null;
      stopHeartbeat();
      callStatusHook('disconnected');

      if (!isClosing) {
        scheduleReconnect();
      }
    };
  }

  // =============================================================
  // HEARTBEAT
  // =============================================================

  /**
   * Inicia el heartbeat: envía ping cada HEARTBEAT_INTERVAL_MS.
   * Si no recibimos pong después de HEARTBEAT_TIMEOUT_MS, reconectamos.
   */
  function startHeartbeat() {
    stopHeartbeat();

    heartbeatTimer = setInterval(function () {
      if (!ws || ws.readyState !== WebSocket.OPEN) {
        stopHeartbeat();
        return;
      }

      // Enviar ping
      ws.send(JSON.stringify({ action: 'ping' }));

      // Si después del timeout no se reseteó heartbeatFailures en onmessage,
      // consideramos la conexión muerta
      heartbeatFailures++;
      if (heartbeatFailures >= 3) {
        console.warn('[KOUD] Heartbeat: 3 pings sin respuesta, reconectando');
        heartbeatFailures = 0;
        ws.close();
        // onclose se encargará de reconectar
      }
    }, HEARTBEAT_INTERVAL_MS);
  }

  /**
   * Detiene el heartbeat.
   */
  function stopHeartbeat() {
    if (heartbeatTimer) {
      clearInterval(heartbeatTimer);
      heartbeatTimer = null;
    }
    heartbeatFailures = 0;
  }

  /**
   * Programa reconexión con exponential backoff.
   */
  function scheduleReconnect() {
    if (isClosing) return;

    reconnectAttempts++;
    var delay = Math.min(
      RECONNECT_BASE_MS * Math.pow(2, reconnectAttempts - 1),
      RECONNECT_MAX_MS
    );

    // Añadimos un poco de jitter aleatorio (±20%)
    delay = delay * (0.8 + Math.random() * 0.4);

    console.log('[KOUD] Reconectando en', Math.round(delay), 'ms (intento', reconnectAttempts + ')');
    callStatusHook('connecting');

    reconnectTimer = setTimeout(function () {
      reconnectTimer = null;
      connect();
    }, delay);
  }

  /**
   * Cierra la conexión WebSocket limpiamente.
   */
  function disconnect() {
    isClosing = true;
    stopHeartbeat();

    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }

    if (ws) {
      ws.onclose = null; // Evita que dispare reconexión
      ws.close();
      ws = null;
    }
  }

  // =============================================================
  // INICIALIZACIÓN
  // =============================================================

  /**
   * Inicializa el widget.
   * Detecta automáticamente si estamos en una página de producto.
   */
  function init() {
    // Si ya hay un badge, no iniciar de nuevo
    if (document.querySelector('.' + BADGE_CLASS)) return;

    var pid = detectProductId();

    if (!isValidProductId(pid)) {
      console.log('[KOUD] No estamos en una página de producto, cancelando');
      return;
    }

    PRODUCT_ID = pid;
    connect();
  }

  // =============================================================
  // HOOKS PARA DEMO / CONTROL EXTERNO
  // =============================================================

  // Exponer funciones para que la demo page las controle
  global.startKoudWidget = init;
  global.disconnectKoud = disconnect;
  global.getKoudState = function () {
    return {
      connected: ws !== null && ws.readyState === WebSocket.OPEN,
      productId: PRODUCT_ID,
      shop: SHOP,
    };
  };

  // Hook opcional para que la demo page actualice su UI
  function callStatusHook(state) {
    if (typeof global.__koudStatusHook === 'function') {
      try { global.__koudStatusHook(state); } catch (_) {}
    }
  }

  // =============================================================
  // CLEANUP
  // =============================================================

  // Cerrar conexión cuando el usuario navega a otra página
  window.addEventListener('beforeunload', function () {
    disconnect();
  });

  // Auto-iniciar SOLO si no estamos en modo manual (demo page)
  if (!global.KOUD_MANUAL) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})(window);
